// this file is generated by generate-icons.js. Do not edit!
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const SVGPlay = props => /*#__PURE__*/_jsx("svg", Object.assign({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  children: /*#__PURE__*/_jsx("path", {
    d: "M4.5 3v18L22 12 4.5 3z"
  })
}));
SVGPlay.displayName = 'SVGPlay';
export default SVGPlay;